// extracted by mini-css-extract-plugin
export default {"container":"TVShowListItem_container__0FKQ5","title":"TVShowListItem_title__4kg1q","img":"TVShowListItem_img__x2Xjh"};